import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  maxWidth: (p) => p.spacing(165),
  mx: 'auto',
  mt: 1.5,
};
